import type { FieldPath, FieldValues } from 'react-hook-form';

import { Select, SelectContent, SelectTrigger, SelectValue } from '@/components/core/select';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../core/form';
import type { FormFieldProps } from './default-form-field';

type Props = React.ComponentProps<typeof SelectTrigger> & {
  children?: React.ComponentProps<typeof SelectContent>['children'];
  placeholder?: React.ComponentProps<typeof SelectValue>['placeholder'];
};

export function SelectFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  description,
  disabled,
  hideError,
  label,
  name,
  placeholder,
  children,

  ...props
}: FormFieldProps<Props, TFieldValues, TName>) {
  return (
    <FormField
      control={control}
      name={name}
      disabled={disabled}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <Select onValueChange={field.onChange} name={field.name} value={field.value}>
            <FormControl>
              <SelectTrigger
                {...props}
                disabled={field.disabled}
                onBlur={field.onBlur}
                ref={field.ref}
              >
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>{children}</SelectContent>
          </Select>
          {description && <FormDescription>{description}</FormDescription>}
          {!hideError && <FormMessage />}
        </FormItem>
      )}
    />
  );
}
